import { useEffect } from "react";

const SITE = "https://jasonhowardphotography.co.uk";
const DEFAULT_IMAGE = `${SITE}/jhp/sunset-bride-groom-wedding-spring-willington-hall-cheshire-jason-howard-101.webp`;

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Per-page SEO: title, description, canonical, Open Graph/Twitter + optional JSON-LD.
export function useSEO({ title, description, canonical, image, type = "website", jsonLd } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    const img = image || DEFAULT_IMAGE;

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "Jason Howard Photography");
    setMeta("property", "og:image", img);
    if (canonical) setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-jsonld", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, canonical, image, type, jsonLd]);
}
